import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="section text-center">
      <h1>404</h1>
      <p className="fs-4">Page not found.</p>
      <Link to="/">Return home</Link>
    </div>
  );
}
